// React

// Material UI
import { FormControl, Select, MenuItem } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// Icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import {
  setShowCustomizeRepeat,
  setRepeated,
} from '../../../../../../../store/customizeRepeatSlice';

const RepeatedPicker = () => {
  const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            cursor: 'pointer',
            padding: '14px 25px 14px 0',
          },
        },
      },
      MuiInput: {
        defaultProps: { disableUnderline: true },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            marginTop: '2px',
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            margin: '7px 0 0 0',
          },
        },
      },
    },
  });

  const repeated = useSelector((state) => state.customizeRepeat.repeated);
  const repeatedOptions = useSelector((state) => state.customizeRepeat.repeatedOptions);
  const dispatch = useDispatch();

  return (
    <ThemeProvider theme={theme}>
      <FormControl>
        <Select
          variant="standard"
          defaultValue="Is not repeated"
          value={repeated}
          onChange={(e) => {
            dispatch(setRepeated(e.target.value));
            dispatch(setShowCustomizeRepeat(e.target.value === 'Customize'));
          }}
          IconComponent={ExpandMoreIcon}
        >
          {repeatedOptions.map((v) => (
            <MenuItem value={v} key={v}>
              {v}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

export default RepeatedPicker;
